import {ConfigService, Trailer} from 'shared';
import {ModelsList, StoreService} from 'shared';
import {Observable} from 'rxjs';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ErrorsService} from 'shared';

@Injectable({
  deps: [HttpClient],
  providedIn: 'root'
})
export class TrailerService extends StoreService<Trailer> {


  constructor(http: HttpClient, config: ConfigService, errors: ErrorsService) {
    super(http, config, errors);
    this.initStore(Trailer);
  }

  protected load(queryParams?: HttpParams): Observable<ModelsList<Trailer>> {
    return this.http.get<ModelsList<Trailer>>(this.config.apiVerUrl('/app/trailers'), {params: queryParams});
  }
  protected insert(values: Trailer): Observable<number> {
    return this.http.post<number>(this.config.apiVerUrl('/app/trailers'), values);
  }

  protected remove(id): Observable<void> {
    return this.http.delete<void>(this.config.apiVerUrl(`/app/trailers/${id}`));
  }

  protected update(id, values): Observable<Trailer> {
    return this.http.put<Trailer>(this.config.apiVerUrl(`/app/trailers/${id}`), values);
  }

  public checkCode(code: string, id?: number): Observable<boolean> {
    return this.http.post<boolean>(this.config.apiVerUrl('/app/trailers/check-code'), {code, id});
  }

}
